import { Base } from './Base.model';

export class WeldGroup extends Base {
  constructor() {
    super();
  }

  public weldGroupId: number;
  public weldGroupName: string;
  public refineryId: number;
}
